
const commonValidatedScopeUiModel = {
    title: "Validated Scope",
    showHistory: false,
    initialValues: { Active: true },
    hideBreadcrumb: true,
    module: 'ScopeMaster',
    idProperty: 'ScopeHookupId',
    columns: [
        { field: 'HuluScopeFamily', label: 'Scope Family' },
        { label: 'Scope Type', field: 'ScopeTypeId', width: 150, type: "select", lookup: 'scopetype' },
        { label: 'Manufacturer', field: 'ManufacturerId', width: 150, type: 'select', lookup: 'manufacturer' },
        { header: 'Use Alcohol', field: 'Alcohol', label: 'Use Alcohol', width: 150, type: 'boolean' },
        { field: 'ScopeModel', width: 150, label: "Scope Model", type: "string" },
        { field: 'StatusId', label: 'Status', type: 'select', width: 150, lookup: 'ScopeStatus' },
        { label: 'Channels', field: 'Channels', type: 'number', width: 150, hidden: true },
        { field: 'MaxScopesPerBasin', type: 'number', width: 200, label: 'Max Scopes Per Basin', min: 1},
        { label: 'Notes', field: 'Notes', multiline: true }
    ]
};

export default commonValidatedScopeUiModel; 